/** Keys for OJK compliance lists persisted in the browser. */
export const OJK_LS_BANNED        = "ojk_banned_entities";
export const OJK_LS_RESTRICTED    = "ojk_restricted_terms";
export const OJK_LS_SEED_KEYWORDS = "ojk_seed_keywords";

/** Keys for the rich row objects (include metadata like risk/category/action). */
export const OJK_LS_ENTITY_ROWS = "ojk_entity_rows";
export const OJK_LS_TERM_ROWS   = "ojk_term_rows";

function isStringArray(value: unknown): value is string[] {
  return Array.isArray(value) && value.every((item) => typeof item === "string");
}

/** Safe read — string arrays: never throws; returns [] on missing/invalid JSON. */
export function readOjkStringArray(key: string): string[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = localStorage.getItem(key);
    if (raw == null || raw === "") return [];
    const parsed: unknown = JSON.parse(raw);
    return isStringArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/** Safe write — string arrays: never throws (quota / private mode). */
export function writeOjkStringArray(key: string, value: string[]): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch { /* ignore */ }
}

/** Safe read — object arrays: returns fallback on missing/invalid JSON. */
export function readOjkRows<T>(key: string): T[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as T[]) : [];
  } catch {
    return [];
  }
}

/** Safe write — object arrays: never throws. */
export function writeOjkRows<T>(key: string, value: T[]): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch { /* ignore */ }
}
